/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignAddonWithPriceDataNameSchema = z.enum(['Campaign Service', 'Contact Service'])

export type CampaignAddonWithPriceDataNameSchema = z.infer<typeof campaignAddonWithPriceDataNameSchema>
